/**
 * Stories on the homepage: real people, their own words.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * REAL PEOPLE AND THEIR OWN WORDS ONLY.
 * Each entry puts a person's first name, country and words on migrada.eu.
 *  - The quote is what the person wrote or said, lightly edited for length,
 *    and approved by them before it goes live. Never write a quote for
 *    someone.
 *  - Add someone only with their written consent to show their first name,
 *    country and words (keep the message in which they agreed).
 *  - `withMigrada: true` only if Migrada actually helped this person. Then
 *    the quote may be about Migrada. Everyone else tells their own move:
 *    what was hard, what they wish they had known. Their card never implies
 *    they used Migrada. Presenting a friend's words as a customer review is
 *    a fake review under EU consumer law (UCPD Annex I, 23b and 23c).
 *
 * While this list is empty the section does not render in production. The
 * development build shows clearly marked samples (stories-sample.ts).
 * ─────────────────────────────────────────────────────────────────────────────
 */
export interface Story {
  /** Stable key. */
  id: string;
  /** First name exactly as the person agreed to show it. */
  name: string;
  /** ISO 3166-1 alpha-2 of the country they moved from. */
  countryCode: string;
  /** Where they moved from and to, e.g. "India to Vienna". */
  route: string;
  /** Their words, approved by them. */
  quote: string;
  /** True only if Migrada helped them. */
  withMigrada: boolean;
  /** Marks development samples; never set on real entries. */
  sample?: boolean;
}

export const stories: Story[] = [];
